module.exports = __webpack_public_path__ + "static/media/ngo-logo.67a15f20.svg";